<script lang="ts" src="./TableCell.ts"/>

<template>
  <div
      class="text-nowrap table-cell"
      :class="{ center: cdata.field.editable?.type === 'checkbox' || isClickable(cdata) }"
  >
    <div v-if="isEnabled(cdata)">
      <!-- errors/help text -->
      <div class="help-text">
        <span v-if="hasHelpText(cdata)" :class="cdata.field.cssClassHelpText">{{ getHelpText(cdata) }}</span>
        <span v-if="hasErrorMessage(cdata)" class="has-error">
          {{ getErrorMessage(cdata) }}
        </span>
      </div>
      <!-- form input -->
      <div v-if="isEditable(cdata)">
        <!-- input number -->
        <div v-if="cdata.field.editable?.type === 'number'">
          <b-form-input
              :type="cdata.field?.editable?.type"
              :value="formattedValue"
              :placeholder="cdata.field.placeholder ?? cdata.field.label"
              class="input-cell"
              v-model.number="formattedValue"
              :class="{ 'has-error': hasError(cdata) }"
              @keyup.enter="ge($event?.target)?.blur()"
              @keyup.space="ge($event?.target)?.blur()"
              @focus="ge($event.target)?.select()"
              :lazyFormatter="true"
              :number="true"
              autocomplete="off"
              :lazy="true"
              @change="onChange(cdata, cdata.field.key, $event)"
              @blur="onBlur(cdata, cdata.field.key)"
              step="0.001"
              :min="0"
          ></b-form-input>
          <!-- rimosso per permettere la gestione degli sfusi -->
          <!--  :step="getEditableStep(cdata)" -->
        </div>
        <div v-else-if="cdata.field.editable?.type === 'checkbox'">
          <b-form-checkbox
              v-model="cdata.value"
              switch="true"
              :class="{ 'has-error': hasError(cdata) }"
              @change="onChange(cdata, cdata.field.key, $event)"
          ></b-form-checkbox>
        </div>
        <!-- input text -->
        <ClearableInput v-else v-model="cdata.value" @change="onChange(cdata, cdata.field.key, $event)">
          <b-form-input
              :type="cdata.field.editable?.type || 'text'"
              v-model="cdata.value"
              class="input-cell"
              :class="{ 'has-error': hasError(cdata) }"
              autocomplete="off"
              @keyup.enter="ge($event.target)?.blur()"
              @focus="ge($event.target)?.select()"
              :lazyFormatter="true"
              :lazy="true"
              @change="onChange(cdata, cdata.field.key, $event)"
              @blur="onBlur(cdata, cdata.field.key)"
              :step="getEditableStep(cdata)"
              :min="0"
          ></b-form-input>
        </ClearableInput>
      </div>
      <!-- button -->
      <div v-else-if="isClickable(cdata)" class="flex-nowrap">
        <b-button
            v-model="cdata.value"
            :name="cdata.field.key"
            :disabled="buttonIsDisabled(cdata)"
            :variant="sv(cdata.field?.button?.variant, 'outline-danger')"
            @click="onChange(cdata, cdata.field.key, $event)"
        >
          {{ sv(cdata.field?.button?.text, "") }}
          <i v-if="cdata.field?.button?.icon" :class="cdata.field?.button?.icon"></i>
        </b-button>
        <!-- bugged
        <b-form-checkbox
          v-model="cdata.value"
          :name="cdata.field.key"
          @change="onChange(cdata, cdata.field.key, $event)"
          :disabled="sv(cdata.field.button?.disabled, false)"
          button
          :buttonVariant="sv(cdata.field?.button?.variant, 'outline-danger')"
        >
          {{ sv(cdata.field?.button?.text, "") }}
          <i v-if="cdata.field?.button?.icon" :class="cdata.field?.button?.icon"></i>
        </b-form-checkbox>
        -->
      </div>
      <div v-else-if="isBoolean(cdata)" class="h3">
        <span v-if="cdata.value">
          <!-- <b-icon-check variant="success"></b-icon-check> -->
          <i class="bi bi-check2"></i>
        </span>
        <span v-else>
          <!-- <b-icon-x-lg variant="danger"></b-icon-x-lg> -->
          <i class="bi bi-x-lg"></i>
        </span>
      </div>
      <!-- in questo div non devono esserci spazi prima del testo -->
      <div v-else>{{ format(cdata) }}</div>
    </div>
    <div v-else>
      <div class="help-text"></div>
      <p v-if="hasDisabledText(cdata)" class="text-secondary">
        {{ getDisabledText(cdata) }}
      </p>
    </div>
    <slot></slot>
  </div>
</template>
<style lang="scss" src="./TableCell.scss" scoped/>
